module.exports = __webpack_public_path__ + "img/blue-gem.93384502.svg";